import z from 'zod';

export const shapes = {
    SaveNotesCommand: z.object({
        content: z.string(),
    }),
    TaskNoteDto: z.object({
        taskId: z.string(),
        content: z.string(),
        updatedAt: z.string().or(z.null()),
    }),
};

export type SaveNotesCommand = z.infer<typeof shapes.SaveNotesCommand>;
export type TaskNoteDto = z.infer<typeof shapes.TaskNoteDto>;
